<template>
    <div class="home">
        <img src="../../static/home.png" mode="bottom left" style="width:100%;height:100%">
        <van-swipe lazy-render class="content" :show-indicators="false" ref="swipe">
            <van-swipe-item v-for="item in roleList" :key="item.id">
                <img :src="item.img" alt="" style="width: 100%;height: 68%;margin-top: 45px;">
                <div class="content_text">
                    <div style="font-size: 20px;font-weight: bold;margin-bottom: 10px;">{{item.name}}</div>
                    <div style="font-size:16px">{{ item.introduce}}</div>
                </div>
                <div class="fl_remove" @click="goLast">
                    <img src="../../static/u11.png" style="width:50px;height: 50px;">
                </div>
                <div class="fl_text">{{item.role}}</div>
            </van-swipe-item>
        </van-swipe>
        <div class="fl_left" @click="goLast">
            <img src="../../static/u54.png" style="width:80%;height: 80%;margin-right: 10px;">
        </div>
        <div class="fl_right" @click="goNext">
            <img src="../../static/u54.png" style="width:80%;height: 80%;margin-left: 10px;transform: rotateY(180deg);">
        </div>
        <div class="btn_start">
            开启互动之旅
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
export default {
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
    },
    data() {
        return {
            roleList: [
                {
                    id: 0,
                    role: '滚京团',
                    img: require('../../static/role1.png'),
                    introduce: '采用糯米粉和生粉和到团，再分成若干小团，搓圆，放入沸水中煮熟。捞出，放入熟豆粉（炒熟的黄豆或玉米碾成粉）、熟芝麻、红糖拌匀成为“豆黄”中反复粘沾，做成粘粉带糖滚芝麻的滚京团。'

                },
                {
                    id: 1,
                    role: '编草扇',
                    img: require('../../static/role21.png'),
                    introduce: '采用九板桥村当地所产的草本植物作原料，选取草本植物中柔韧的秆、皮、芯、叶、根，竖经横纬，纯手工通过编、结、辫、扣、扎、绞、缠、网、串、盘等丰富的手法和编结技法，编织成草扇。'
                },
                {
                    id: 2,
                    role: '砌墙磡',
                    img: require('../../static/role3.png'),
                    introduce: '河边的石砌墙，叫做“石磡”，石磡按照纵联砌置法构筑而成，或设置石耳，用来拴小船，或设有埗头，方便村民挑水、洗涤，以及运载货物时上下河涌。而岸上每条巷口对开会或设有穿过石砌墙的用于排放污水的水渠口。'
                },
                {
                    id: 3,
                    role: '凿碗字',
                    img: require('../../static/role4.png'),
                    introduce: '先将字样描写在碗底，通过一把凿子和一把锤子，依笔迹的每一笔横竖撇捺折笔划都凿上一个个连续的的洞，按指定字样凿在碗底后，再用破布蘸墨一擦，然后把字的周围清洗干净，墨迹就深入到凿出来的字上了，永远不会褪色。'
                }
            ]

        }
    },
    methods: {
        goLast() {
            this.$refs.swipe.prev()
        },
        goNext() {
            this.$refs.swipe.next()
            
        }
    }
}
</script>
<style scoped>










.home {
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: transparent url('../../static/homeBackground.png') 0% 0% no-repeat padding-box;
    opacity: 1;
    position: relative;
}

.content {
    background-color: rgba(242, 242, 242, 1);
    width: 80%;
    height: 550px;
    margin-top: 20px;
    box-sizing: border-box;
    border-radius: 15px;
    position: absolute;
    top: 0;
}

.content_text {
    box-sizing: border-box;
    padding: 0 15px;
}
.btn_start {
    background-color: rgba(242, 242, 242, 1);
    margin-top: 20px;
    width: 80%;
    height: 60px;
    font-size: 20px;
    text-align: center;
    line-height: 60px;
    border-radius: 10px;
    font-weight: bold;
}

.fl_remove {
    position: absolute;
    top: 10px;
    right: 10px;
}

.fl_left {
    position: absolute;
    width: 55px;
    height: 55px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #898787b3;
    top: 25%;
    left: 20px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 6px;
    /* margin-left: -30px; */

}

.fl_right {
    position: absolute;
        width: 55px;
        height: 55px;
        background-color: rgba(255, 255, 255, 1);
        overflow: hidden;
        border-radius: 50%;
        border: 1px solid #898787b3;
        top: 25%;
        right: 20px;
        text-align: center;
        box-sizing: border-box;
        padding-top: 6px;
        /* margin-right: -30px; */
}

.fl_text {
    position: absolute;
    font-size: 25px;
    font-weight: bold;
    margin: 0 auto;
    width: 25px;
    top: 50px;
    left: 30px;
}
</style>